// @ts-nocheck
import { i18n } from '@/i18n'

 export function NetMonitor(url, timing) {
    this.defaultUrl = url;
    this.defaultTiming = timing > 0 ? timing :10000;
    NetMonitor.prototype.timing = () => {
        //createDiv();
        let http = new Http(url);
        let list = new LinkList();
        let timer = setInterval(() => {
            getTime(http, list);
        }, this.defaultTiming);
    }


    function  getTime(http, list) {
        //普通get请求
        let sendDate = new Date().getTime();

        return new Promise(function(resolve) {
            http.get(http.defaultUrl, function (err, result) {
                let responseTimeMs = 10000;
                if (err != null) {
                    let  status = err;
                    console.info(err + "")
                } else {
                    let receiveDate = (new Date()).getTime();
                    responseTimeMs = receiveDate - sendDate;
                }

                if (list.size() >= 10) {
                    list.removeAt(0);
                }

                list.append(responseTimeMs);
                refreshDiv(responseTimeMs);
            })
        });
    }

    function Http(url) {
        //设置默认调用url
        this.defaultUrl = url;

        this.quest = function (option, callback) {
            let url = option.url;
            let method = option.method;
            let data = option.data;
            let timeout = option.timeout || 0;

            let xhr = new XMLHttpRequest();
            (timeout > 0) && (xhr.timeout = timeout);
            xhr.onreadystatechange = function () {
                if (xhr.readyState === 4) {
                    if (xhr.status >= 200 && xhr.status < 400) {
                        let result = xhr.responseText;
                        try { result = JSON.parse(xhr.responseText); } catch (e) { }
                        callback && callback(null, result);
                    } else {
                        callback && callback(xhr.status);
                    }
                }
            };
            xhr.open(method, url, true);
            if (typeof data === 'object') {
                try {
                    data = JSON.stringify(data);
                } catch (e) { }
            }
            xhr.send(data);
            xhr.ontimeout = function () {
                callback && callback('timeout');
                console.log('timeout');
            };
        };
        this.get = function (url, callback) {
            let option = url.url ? url : { url: url };
            option.method = 'get';
            this.quest(option, callback);
        };
        this.post = function (option, callback) {
            option.method = 'post';
            this.quest(option, callback);
        };
    }

    function createDiv() {
        var div=document.createElement("div");
        div.id="net_monitor_div";
        div.style="height: 40px; margin: 0 auto; overflow: hidden; position: relative; text-align: left; top: 5px;";
        div.innerHTML="<p style=\"color: #FFF; width: 100%; position: absolute;  bottom: 0;\">\n" +
            i18n.t('reqRespTime') + 0 + "ms</p>";
        document.body.appendChild(div);
    }

    function refreshDiv(responseTime) {
        var div=document.getElementById("net_monitor_div");
        if(div) {
            div.style="height: 40px; margin: 0 auto; overflow: hidden; position: relative; text-align: left; top: 5px;";

            let innerHTML ="<p style=\"color: #FFF; width: 100%; position: absolute;  bottom: 0;";

            innerHTML += "\">\n";
            if (responseTime >= 10000) {
                innerHTML += i18n.t('netNotWork') + "</p>";
            } else {
                innerHTML += i18n.t('reqRespTime') + responseTime + "ms</p>";
            }
            div.innerHTML = innerHTML;
        }

        window.responseNetTime = responseTime
        var event = new Event('responseNetTime');
        window.dispatchEvent(event);
    }


}


function LinkList(){
    // 封装一个内部类：节点类
    function Node(data){
        this.data = data;
        this.next = null;
    }

    // 属性
    // 属性head指向链表的第一个节点
    this.head = null;
    this.length = 0;

    // 一.实现append方法
    LinkList.prototype.append = data => {
        //1.创建新节点
        let newNode = new Node(data)

        //2.添加新节点
        //情况1：只有一个节点时候
        if(this.length == 0){
            this.head = newNode
            //情况2：节点数大于1，在链表的最后添加新节点
        }else {
            //让变量current指向第一个节点
            let current = this.head
            //当current.next(下一个节点不为空)不为空时，一直循环，直到current指向最后一个节点
            while (current.next){
                current = current.next
            }
            // 最后节点的next指向新的节点
            current.next = newNode
        }
        //3.添加完新结点之后length+1
        this.length += 1
    }

    // 二.实现toString方法
    LinkList.prototype.toString = () => {
        // 1.定义变量
        let current = this.head
        let listString = ""

        // 2.循环获取一个个的节点
        while(current){
            listString += current.data + " "
            current = current.next//千万不要忘了拼接完一个节点数据之后，让current指向下一个节点
        }
        return  listString
    }

    // 三.实现insert方法
    LinkList.prototype.insert = (position, data) => {
        //理解positon的含义：position=0表示新界点插入后要成为第1个节点，position=2表示新界点插入后要成为第3个节点
        //1.对position进行越界判断:要求传入的position不能是负数且不能超过LinkList的length
        if(position < 0 || position > this.length){
            return false
        }
        //2.根据data创建newNode
        let newNode = new Node(data)

        //3.插入新节点
        //情况1：插入位置position=0
        if(position == 0){
            // 让新节点指向第一个节点
            newNode.next = this.head
            // 让head指向新节点
            this.head = newNode
            //情况2：插入位置position>0(该情况包含position=length)
        } else{
            let index = 0
            let previous = null
            let current = this.head
            //步骤1：通过while循环使变量current指向position位置的后一个节点(注意while循环的写法)
            while(index++ < position){
                //步骤2：在current指向下一个节点之前，让previous指向current当前指向的节点
                previous = current
                current = current.next
            }
            // 步骤3：通过变量current(此时current已经指向position位置的后一个节点)，使newNode指向position位置的后一个节点
            newNode.next = current
            //步骤4：通过变量previous，使position位置的前一个节点指向newNode
            previous.next = newNode

            //我们无法直接操作链表中的节点，但是可以通过变量指向这些节点，以此间接地操作节点；
        }
        //4.新节点插入后要length+1
        this.length += 1;

        return true
    }

    //四.实现get方法
    LinkList.prototype.get = (position) => {
        //1.越界判断
        // 当position = length时，取到的是null所以0 =< position < length
        if(position < 0 || position >= this.length){
            return null
        }
        //2.获取指定的positon位置的后一个节点的data
        //同样使用一个变量间接操作节点
        let current = this.head
        let index = 0
        while(index++ < position){
            current = current.next
        }
        return current.data
    }

    //五.实现indexOf方法
    LinkList.prototype.indexOf = data => {
        //1.定义变量
        let current = this.head
        let index = 0

        //2.开始查找:只要current不指向null就一直循环
        while(current){
            if(current.data == data){
                return index
            }
            current = current.next
            index += 1
        }

        //3.遍历完链表没有找到，返回-1
        return -1
    }

    //六.实现update方法
    LinkList.prototype.update = (position, newData) => {
        //1.越界判断
        //因为被修改的节点不能为null，所以position不能等于length
        if(position < 0 || position >= this.length){
            return false
        }
        //2.查找正确的节点
        let current = this.head
        let index = 0
        while(index++ < position){
            current = current.next
        }
        //3.将position位置的后一个节点的data修改成newData
        current.data = newData
        //返回true表示修改成功
        return true
    }

    //七.实现removeAt方法
    LinkList.prototype.removeAt = position => {
        //1.越界判断
        if (position < 0 || position >= this.length) {
            return null
        }
        //2.删除元素
        //情况1：position = 0时(删除第一个节点)
        let current = this.head
        if (position ==0) {
            //情况2：position > 0时
            this.head = this.head.next
        }else{
            let index = 0
            let previous = null
            while (index++ < position) {
                previous = current
                current = current.next
            }
            //循环结束后，current指向position后一个节点，previous指向current前一个节点
            //再使前一个节点的next指向current的next即可
            previous.next = current.next
        }
        //3，length-1
        this.length -= 1

        //返回被删除节点的data，为此current定义在最上面
        return current.data
    }

    /*-------------其他方法的实现--------------*/
    //八.实现remove方法
    LinkList.prototype.remove = (data) => {
        //1.获取data在列表中的位置
        let position = this.indexOf(data)
        //2.根据位置信息，删除结点
        return this.removeAt(position)
    }

    //九.实现isEmpty方法
    LinkList.prototype.isEmpty = () => {
        return this.length == 0
    }

    //十.实现size方法
    LinkList.prototype.size = () => {
        return this.length
    }
}
